<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 border-radius-xl p-3" style="background-color: #FFF;">
        <!-- #F5F6F7 -->
        <div>
          <h4 class="text-center">Configuración SOA</h4>
          <hr class="horizontal dark" />
          <Card>
            <template #title>Parámetros de Conexión SOA</template>
            <template #subtitle>
              <InputSwitch v-model="blocked" id="editar-activo"/>
              <span v-if="!blocked" style="position: relative; top: -11px; left: 5px; color: #cecece;"><i class="fas fa-lock"></i></span>
              <span v-if="blocked" style="position: relative; top: -11px; left: 5px; color: #cecece;"><i class="fas fa-lock-open"></i></span>
            </template>
            <template #content>
              <BlockUI :blocked="!blocked" class="p-4">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <label for="nombre">URL <span class="text-danger">*</span></label>
                    <InputText id="nombre" class="form-control" v-model="editar.nombre"/>
                  </div>
                  <div class="col-md-6">
                    <label for="nombre">Username <span class="text-danger">*</span></label>
                    <InputText id="nombre" class="form-control" v-model="editar.nombre"/>
                  </div>
                  <div class="col-md-6">
                    <label for="nombre">Password <span class="text-danger">*</span></label>
                    <Password v-model="editar.password" placeholder="Password" :feedback="false" toggleMask class="w-100" />
                  </div>
                  <div class="col-md-12 mt-4" style="text-align:end;">
                    <button class="btn btn-addiuva-dark" @click="createAgency" v-if="!editar.id">
                      <i class="fas fa-save pr-1"></i> Guardar
                    </button>
                  </div>
                </div>
              </BlockUI>
            </template>
          </Card>
          <Toast />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toast from 'primevue/toast';
import InputText from 'primevue/inputtext';
import InputSwitch from 'primevue/inputswitch';
import Password from 'primevue/password';
import Card from 'primevue/card';
import BlockUI from 'primevue/blockui';

// import axios from 'axios';
// import authHeader from '../services/auth-header';
export default {
  name: "config-soa",
  components: {
    Toast,
    InputText,
    InputSwitch,
    Card,
    Password,
    BlockUI
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      blocked: false,
      showProfileDropdown: false,
      periodos: [],
      editar: {
        visible: false,
        title: null,
        id: null,
        nombre: null,
        meses_cubiertos: null,
      },
      departamentosOptions: [],
    };
  },
  methods: {
    defineSubMenu(data) {
      let items = [
        {
          label: 'Editar',
          icon: 'fas fa-pen',
          command: () => {
              this.iniciarEdicion(data)
          }
        }
      ];
      return items;
    },
    getSeverity(status) {
      let severity = null;
      if (status == true) {
        severity = "success"
      } else {
        severity = "danger";
      }
      return severity;
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    // Edicion
    iniciarEdicion(data) {
      this.editar = {
        visible: true,
        title: 'Editar Periodo',
        id: data.id,
        nombre: data.nombre,
        meses_cubiertos: data.meses_cubiertos,
        activado: data.activado,
      };
    },
    closeModal() {
      this.editar = {
        visible: false,
        title: null,
        id: null,
        nombre: null,
        meses_cubiertos: null,
        activado: null,
      };
    },
    // Restauración
    iniciarCrearPeriodo() {
      this.editar = {
        visible: true,
        title: 'Crear Periodo',
        id: null,
        nombre: null,
        meses_cubiertos: null,
        activado: true,
      }
    },
    formatDate: function (date) {
      let aDate = date.split('/');
      return new Date(aDate[2], parseInt(aDate[1])-1, aDate[0]);
    },
    validateRoute(){
      let menus = this.getProfileMe.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Home'});
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.validateRoute();
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
.p-component-overlay {
    background-color: rgb(105 10 164 / 25%);
    transition-duration: 0.2s;
    border-radius: 1rem;
    z-index: 10 !important;
}
</style>